import { handleUnit, normalisePrice } from 'lib/utils';
import ProductBadge from 'components/product_show/product_badge';
import getBadgeVariant from 'utils/getBadgeVariant';

interface VATPriceProps {
  price: number; // inclusive vat price
  excVATPrice: number; // exclusive vat price
  quantity: number; // product 'quantity' value
  unit: string; // product unit value
  excVat: boolean; // VAT Toggle state (true = show exc VAT/ false = show inc VAT)
  priceBeforeCurrentSale?: number; // Exclusive VAT sale sale price
  priceBeforeCurrentSaleIncVAT?: number; // inclusive VAT sale price
  isOnClearance: boolean; // if true - highlight price in red and add great price badge
  isRedemptionOffer: boolean; // if true - highlight price in red and add redemption offer badge
}

const VATPrice = ({
  price,
  excVATPrice,
  quantity,
  unit,
  excVat,
  priceBeforeCurrentSale,
  priceBeforeCurrentSaleIncVAT,
  isOnClearance,
  isRedemptionOffer,
}: VATPriceProps) => {
  const isOnSale = priceBeforeCurrentSale && priceBeforeCurrentSaleIncVAT;

  const badgeVariant = getBadgeVariant({
    priceBeforeCurrentSale,
    priceBeforeCurrentSaleIncVAT,
    isOnClearance,
    isRedemptionOffer,
  });

  return (
    <div className="cef-vat-price">
      {badgeVariant && <ProductBadge variant={badgeVariant} />}
      <div>
        <p
          className={`cef-vat-price__main fl fl-row fw-nw ai-baseline${
            isOnSale || isOnClearance ? ' tc-cef-red' : ' tc-black'
          }`}
          data-testid="vat-price-main">
          <span className="cef-vat-price__currency">&pound;</span>
          {normalisePrice(excVat ? excVATPrice : price, false)}
          <span className="cef-vat-price__per tc-grey-70 ws-nw mr-10">
            For {quantity}
            {handleUnit(unit)}
          </span>
          {isOnSale && (
            <span className="fs-21 fw-400 ws-nw tc-main cef-vat-price__price-before-current-sale">
              Was{' '}
              <span className="td-lt">
                {normalisePrice(
                  excVat
                    ? priceBeforeCurrentSale
                    : priceBeforeCurrentSaleIncVAT,
                )}
              </span>
            </span>
          )}
        </p>

        <p
          className="cef-vat-price__secondary"
          data-testid="vat-price-secondary">
          {normalisePrice(excVat ? price : excVATPrice)} {excVat ? 'Inc' : 'Ex'}{' '}
          VAT
        </p>
      </div>
    </div>
  );
};

export default VATPrice;
